module.exports = __webpack_public_path__ + "img/Mountain.d1c1488b.png";